import React, { Fragment } from 'react'

import classNames from 'classnames'

import { CommonRouteArrowIcon } from '@local/assets/icons'

import styles from './TrainTicketDisplayName.module.scss'

function TrainTicketDisplayName({ stationNames, isHeader }: { stationNames: string[]; isHeader?: boolean }) {
  return (
    <>
      {stationNames.map((station, index) => {
        return (
          <Fragment key={station}>
            <span>{station}</span>
            {index !== stationNames.length - 1 && (
              <span>
                <CommonRouteArrowIcon
                  className={classNames(styles.icon_route, { [styles.type_header]: isHeader })}
                  aria-hidden="true"
                />
              </span>
            )}
          </Fragment>
        )
      })}
    </>
  )
}

export default TrainTicketDisplayName
